import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import LocationSelector from './LocationSelector';
import ProductPreview from '../../Menu__b/components/ProductPreview';
import ComboPreview from '../../../../Combo/ComboList/components/ComboPreview';
import ConfirmationDialog from './ConfirmationDialog';
import useLocation from '../../../../../customHooks/useLocation';
import {PICKUP, DELIVERY} from '../../../../OrderSetting/orderSettingTypes';
import {navigate} from 'gatsby';

const ProductDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 10px;

  @media (max-width: 786px) {
    margin-top: -50px;
    display: block;
    margin-top: 12px;
    text-align: center;
  }
`;

const ShowMoreButton = styled.a`
  grid-column: 1 / span 2;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  justify-content: center;
  margin-top: 10px;
  text-align: center;
`;

function GroupedMenu({
  hits,
  refine,
  cart,
  location,
  locations,
  emptyCart,
  menuProducts,
  specialHours,
  selectedLocation,
  updateInterOrderType,
  getProductToConfigure,
  handleComboPreviewClick,
  updateOrderSettingModalIsVisible,
  changePickUpLocationFromLocationsPage,
  orderSettingModalIsVisible,
  updateOrderType,
  productCustomizerReducer,
  updateSelectedLocation,
  orderSettingReducer,
}) {
  const [showMore, setShowMore] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [orderFromHere, setOrderFromHere] = useState(null);

  const {currentLocation, interOrderType} = useLocation();
  const {productCustomizerIsVisible} = productCustomizerReducer;

  useEffect(() => {
    if (
      menuProducts &&
      selectedProduct &&
      menuProducts[0].name.includes(location.name.split(' ')[0]) &&
      !orderSettingModalIsVisible
    ) {
      if (selectedProduct.is_combo) {
        handleComboPreviewClick(selectedProduct.combo_id);
      } else {
        getProductToConfigure(selectedProduct.product_id);
      }
      setSelectedProduct(null);

      if (location.accepted_order_types.includes(PICKUP)) {
        updateInterOrderType(PICKUP);
      } else if (location.accepted_order_types.includes(DELIVERY)) {
        updateInterOrderType(DELIVERY);
      }
    }
  }, [menuProducts]);

  useEffect(() => {
    if (selectedProduct && !productCustomizerIsVisible) {
      setSelectedProduct(null);
    }
  }, [productCustomizerIsVisible]);

  const locationProducts = hits.filter(
    hitLocation => hitLocation.business_id === location.id
  );

  const selectProduct = productId =>
    hits.find(
      product =>
        product.product_id === productId && product.business_id === location.id
    );

  const handleProductPreviewClick = (productId, product) => {
    const locationInfo = locations.filter(
      location => location.id === product.business_id
    )[0];

    if (locationInfo.accepted_order_types.includes(interOrderType)) {
      if (product.business_id === selectedLocation.id) {
        getProductToConfigure(productId);
      } else {
        setIsDialogOpen(true);
      }
    } else {
      if (
        locationInfo.accepted_order_types.length === 1 &&
        locationInfo.accepted_order_types[0] === DELIVERY
      ) {
        updateInterOrderType(DELIVERY);
      }

      updateOrderSettingModalIsVisible(true);
    }

    setSelectedProduct(product);
  };

  const onComboClick = (comboId, product) => {
    const locationInfo = locations.filter(
      location => location.id === product.business_id
    )[0];

    setSelectedProduct(product);

    if (locationInfo.accepted_order_types.includes(interOrderType)) {
      if (product.business_id === selectedLocation.id) {
        handleComboPreviewClick(comboId);
      } else {
        setIsDialogOpen(true);
      }
    } else {
      if (
        locationInfo.accepted_order_types.length === 1 &&
        locationInfo.accepted_order_types[0] === DELIVERY
      ) {
        updateInterOrderType(DELIVERY);
      }

      updateOrderSettingModalIsVisible(true);
    }
  };

  const onGoToMenuClick = () => {
    const locationInfo = selectedProduct
      ? locations.filter(
          location => location.id === selectedProduct.business_id
        )[0]
      : orderSettingReducer.selectedLocation
      ? locations.filter(
          location => location.name === orderSettingReducer.selectedLocation
        )[0]
      : null;

    if (
      locationInfo.accepted_order_types.length === 1 &&
      locationInfo.accepted_order_types[0] === DELIVERY
    ) {
      updateInterOrderType(DELIVERY);
    } else updateInterOrderType(PICKUP);

    if (!orderFromHere) {
      updateSelectedLocation(locationInfo.name);
    } else {
      updateSelectedLocation(orderFromHere.name);
      setOrderFromHere(null);
      setSelectedProduct(null);
    }

    setIsDialogOpen(false);

    updateOrderSettingModalIsVisible(true);
  };

  const onLocationChange = location => {
    setOrderFromHere(location);
    changePickUpLocationFromLocationsPage(location);

    if (
      (location && !location.is_order_ahead_enabled) ||
      (location && !location.accepting_orders) ||
      (location && !location.open)
    ) {
      refine('');
      navigate('/menu');
    }

    updateOrderSettingModalIsVisible(true);
    setOrderFromHere(null);
  };

  const productsArray = showMore
    ? locationProducts
    : locationProducts.slice(0, 4);

  return (
    <div>
      <LocationSelector
        location={location}
        specialHours={specialHours}
        updateInterOrderType={orderType => updateInterOrderType(orderType)}
        changePickUpLocationFromLocationsPage={selectedLocation =>
          onLocationChange(selectedLocation)
        }
        updateOrderSettingModalIsVisible={bool =>
          updateOrderSettingModalIsVisible(bool)
        }
        setLocationToShowOnMobile={location => onLocationChange(location)}
        currentLocation={currentLocation}
        refine={refine}
        updateSelectedLocation={updateSelectedLocation}
        setIsDialogOpen={setIsDialogOpen}
        isDialogOpen={isDialogOpen}
        setSelectedProduct={setSelectedProduct}
      />
      <ProductDiv>
        {productsArray
          ? productsArray.map(product =>
              !product.is_combo ? (
                <div style={{marginTop: '10px'}}>
                  <ProductPreview
                    key={product.product_id}
                    product={selectProduct(product.product_id)}
                    handleProductPreviewClick={(productId, product) =>
                      handleProductPreviewClick(productId, product)
                    }
                  />
                </div>
              ) : (
                <div style={{marginTop: '10px'}}>
                  <ComboPreview
                    key={product.product_id}
                    combo={product}
                    handleComboPreviewClick={(comboId, product) =>
                      onComboClick(comboId, product)
                    }
                  />
                </div>
              )
            )
          : null}
        {locationProducts.length > 4 ? (
          <ShowMoreButton
            onClick={() => (showMore ? setShowMore(false) : setShowMore(true))}
          >
            {showMore ? 'Show Less' : 'View All Products'}
          </ShowMoreButton>
        ) : null}
      </ProductDiv>
      <ConfirmationDialog
        cart={cart}
        open={isDialogOpen}
        location={selectedLocation}
        close={() => setIsDialogOpen(false)}
        onGoToMenuClick={() => onGoToMenuClick()}
      />
    </div>
  );
}

export default GroupedMenu;
